/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOfferFile } from './APIOfferFile';
import {
    APIOfferFileFromJSON,
    APIOfferFileFromJSONTyped,
    APIOfferFileToJSON,
} from './APIOfferFile';

/**
 * 
 * @export
 * @interface APIPaginatedOfferFileList
 */
export interface APIPaginatedOfferFileList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedOfferFileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOfferFileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOfferFileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIOfferFile>}
     * @memberof APIPaginatedOfferFileList
     */
    results: Array<APIOfferFile>;
}

/**
 * Check if a given object implements the APIPaginatedOfferFileList interface.
 */
export function instanceOfAPIPaginatedOfferFileList(value: object): value is APIPaginatedOfferFileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedOfferFileListFromJSON(json: any): APIPaginatedOfferFileList {
    return APIPaginatedOfferFileListFromJSONTyped(json, false);
}

export function APIPaginatedOfferFileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedOfferFileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIOfferFileFromJSON)),
    };
}

export function APIPaginatedOfferFileListToJSON(value?: APIPaginatedOfferFileList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIOfferFileToJSON)),
    };
}

